<template>
  <div>
    <div style="padding: 0.27rem 0.27rem 0">
      <DaliProgressV3 :processGraphic="processGraphic" :current-process-code="currentProcessCode" :programId="programId"  @chooseAbility="handleChooseAbility" @finish="removeLister"></DaliProgressV3>
    </div>
    <div>
      <div v-if="currentProcessCode=='upload'">
        <a-tabs :default-active-key="processGraphic?.graphicItemMap.upload.children[0].code">
          <a-tab-pane :key="item.code" :tab="item.name" v-for="item in processGraphic?.graphicItemMap.upload.children">
            <handleFinalSettlement :programId="programId" :skuId="skuId" :ability-code="item.code"></handleFinalSettlement>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div v-else-if="currentProcessCode=='data_authorize'">
        <div class="topselect">
          <div @click="changeType(1)" :class="index == 1 ? 'active' : ''">
            企业检测
          </div>
          <div @click="changeType(2)" :class="index == 2 ? 'active' : ''">
            代理检测
          </div>
          <div @click="changeType(3)" :class="index == 3 ? 'active' : ''" v-if="hasScanQrcodeLogin">
            扫码检测
          </div>
        </div>
        <left v-if="index == 1" :info="companyInfo" :aName="appTypeName" :jzm="validateMethod" :pId="programId" :icd="isChecked" :idm="isDemo"  :skuId="skuId"></left>
        <right v-if="index == 2" :info="companyInfo" :aName="appTypeName" :jzm="validateMethod" :pId="programId" :icd="isChecked" :idm="isDemo"></right>
        <QrAuthorize  v-if="index == 3" :info="companyInfo" :aName="appTypeName" :jzm="validateMethod" :pId="programId" :icd="isChecked" :idm="isDemo" :skuId="skuId"></QrAuthorize>
      </div>
    </div>


  </div>
</template>
<script>
import left from "./left.vue";
import right from "./right.vue";
import { isJSON } from "@/utils/helper.js"

import {
  getAuthToken,
  savePrepareFromSecond,
  getPrepareInfo, getProcessGraphicBySkuId, savePrepare, getGoodsDetail,
} from "@/api/openNew.js";

import { cloneDeep } from "lodash";
import DaliProgressV3 from "@/pages/openNew/component/DaliProgressV3.vue";
import HandleFinalSettlement from "@/pages/openNew/component/handleFinalSettlement.vue";
import QrAuthorize from "@/pages/openNew/QrAuthorize.vue";

export default {
  components: {
    QrAuthorize,
    HandleFinalSettlement,
    DaliProgressV3,
    left,
    right,
  },
  data() {
    return {
      index: 1,
      hasScanQrcodeLogin:false, // 是否支持扫码登录
      companyInfo: {
        companyName: "",
        userName: "",
        userCode: "",
        password: "",
        identityType: 3,
        phoneNumber: "",
        time:[]
      },
      checkTimer: null,
      processGraphic:{},
      infos:{},
      getInfo:{},
      appTypeName: "",
      validateMethod: 1, //验证方式 1密码 2验证码
      programId: "",
      isChecked: false,
      isDemo: undefined,
      currentProcessCode:'data_authorize',
    };
  },
  async mounted() {
    this.cacheAuthInfo()
    this.loadProcessGraphic()
    window && window.parent && window.parent.postMessage("Ready", "*");

    window.addEventListener("message", this.receiveMsg, false);

    this.checkTimer = window.setInterval(() => {
      this.loadProcessGraphic()
    }, 20000);

    if (this.$route.name == 'oemGuardV5') {
      await this.loadGoodsDetail()
      let accessToken = this.$route.query.accessToken
      localStorage.setItem('accessToken', accessToken)
      //获取三方授权信息并保存
      await this.savePrepareApi()
    }
  },
  beforeUnmount() {
    this.removeLister()
  },
  destroyed() {
    this.removeLister()
  },
  methods: {
    removeLister() {
      clearInterval(this.checkTimer)
    },
    async loadGoodsDetail(){
      if (this.skuId){
        const res = await getGoodsDetail({
          skuId: this.skuId
        })
        this.goodsDetail = res.data
      }

    },
    async savePrepareApi () {
      console.log("savePrepareApi")
      // this.str = encodeURIComponent(this.$route.query.redirect_uri)
      this.str = this.$route.query.redirect_uri
      const params = {
        state: this.$route.query.state,
        skuId: this.$route.query.skuId,
        redirectUri: decodeURIComponent(this.str)
        // redirectUri:decodeURIComponent(this.$route.query.redirect_uri)
      }
      const res = await savePrepare(params)
      if (res.code == 200) {
        this.programId = res.data.programId
        //this.programId = '08b9914a03764276bae5138479c3217e'
      }
    },
    handleChooseAbility(code){
      // const processGraphic = cloneDeep(this.processGraphic)
      // processGraphic.currentItemCode = code
      // this.processGraphic = processGraphic
      this.currentProcessCode = code
    },
    async loadProcessGraphic() {
      const res = await getProcessGraphicBySkuId({
        skuId:this.skuId
      });
      const processGraphic = cloneDeep(res.data)
      processGraphic.currentItemCode='data_authorize'
      this.processGraphic= processGraphic
      this.hasScanQrcodeLogin = res.data.hasScanQrcodeLogin
    },
    async saveCompanny (e) {

      const params = {
        programId: e.programId || '',
        taxNo: e.companyNo,
        companyName: e.companyName,
        startDate: e.startYear,
        endDate: e.endYear,
        appTypeName: this.appTypeName,
        remainDays: e.remainDays ? e.remainDays : ''
      }
      if(this.appTypeName == 'lvat' || this.appTypeName == 'eit'){
        params.state=JSON.stringify({projectId:this.getInfo.projectId||''})
      }
      const res = await savePrepareFromSecond(params)
      if (res.code == 200) {
        this.programId = res.data.programId
        const params = {
          messageInfo: 'setProgramId',
          value: this.programId
        }
        window.parent && window.parent.postMessage(JSON.stringify(params), "*");

      }

    },
    async cacheAuthInfo() {
      if (this.$route.query.accessToken) {
        localStorage.setItem("accessToken", this.$route.query.accessToken);
      }

      // if (this.$route.query.skuId) {
      //   localStorage.setItem("skuId", this.$route.query.skuId);
      // }
      //
      // if (this.$route.query.state) {
      //   localStorage.setItem("state", this.$route.query.state);
      // }
      //
      // if (this.$route.query.redirect_uri) {
      //   localStorage.setItem("redirect_uri", this.$route.query.redirect_uri);
      // }
    },
    async receiveMsg(e,isfirst=true) {
      if (isJSON(e.data)) {
        let info = JSON.parse(e.data);

        if (info.messageInfo == "setMessage") {

          if(isfirst){
          this.infos = cloneDeep(info)

          }
          this.getInfo = info;
          this.appTypeName = info.appTypeName;
          this.companyInfo.companyName = info.companyName;
          this.programId = info.programId || "";
          this.isDemo = info.isDemo || false;
          if(this.index == 1){
            this.companyInfo.userName = info.companyNo;
            delete this.companyInfo.agentTaxNo
          }else{
            this.companyInfo.agentTaxNo = info.companyNo;
            this.companyInfo.userName = '';

          }
          if(isfirst){
            await this.cacheAuthInfo();
            await this.saveCompanny(info);
            const res = await getPrepareInfo({ programId: this.programId });
            if (res.code == 200) {
              this.validateMethod = res.data.validateMethod;
            }
          }

        }
      } else {
        if (e.data == "message") {
          this.isChecked = true;
        }
      }
    },
    changeType(e) {
      this.index = e;
      this.receiveMsg({data:JSON.stringify(this.infos)},false)
    },
  },
  computed: {
    skuId() {
      return this.$route.query.skuId
    },
  }
};
</script>
<style scoped lang="stylus">
.topselect {
  margin-top: 27px;
  padding: 0.27rem;
  padding-top: 0;
  display: flex;
  > div {
    cursor: pointer;
    font-family: PingFang SC;
    color: #1d2129;
    font-weight: 400;
    font-size: 16px;
    padding-bottom: 8px;
  }
  div.active {
    color: #165dff;
    font-weight: 600;
    font-size: 16px;
    border-bottom: 3px solid #165dff;
  }
  div + div {
    margin-left: 40px;
  }
}
@media screen and (max-width: 768px) {
  .topselect {
    box-sizing: border-box;
    margin-top: 15px;
    div:first-child {
      border-radius: 4px 0px 0px 4px;
    }
    > div {
      text-align: center;
      border: 2px solid #dfdfe0;
      width: 50%;
      height: 33px;
      line-height: 1.5;
      padding-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    > div.active {
      border: 0;
      color: white;
      background-color: #165dff;
      font-weight: 400;
    }
    > div + div {
      border-radius: 0px 4px 4px 0px;

      margin-left: 0;
    }
  }
}
</style>
